var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22562 17.5127H0.769796V6.40205H4.22562V17.5127ZM2.47913 4.91568C1.40151 4.91568 0.509681 3.98669 0.509681 2.87191C0.509681 1.34838 2.14469 0.382237 3.48243 1.16258C4.11414 1.49702 4.48573 2.16589 4.48573 2.87191C4.48573 3.98669 3.59391 4.91568 2.47913 4.91568ZM17.1199 17.5127H13.7012V12.1246C13.7012 10.824 13.6641 9.189 11.8804 9.189C10.0968 9.189 9.83668 10.5639 9.83668 12.0131V17.5127H6.38086V6.40205H9.68804V7.92558H9.7252C10.2083 7.07092 11.3231 6.14194 12.9952 6.14194C16.4882 6.14194 17.1571 8.44581 17.1571 11.4186V17.5127H17.1199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.719054ca90d507034f5e9503caf6ea07.svg";
export { ForwardRef as ReactComponent };